import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	FormLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface IndustryOptions {
	id: number;
	name: string;
}

interface SelectIndustryStepProps {
	value: number[];
	onChange: (value: number[]) => void;
	options: IndustryOptions[];
	error?: string;
}

export default function SelectIndustryStep({
	value,
	onChange,
	options,
	error,
}: SelectIndustryStepProps) {
	const { t } = useTranslation();

	const handleToggle = (id: number) => {
		if (value.includes(id)) {
			onChange(value.filter((v) => v !== id));
		} else {
			onChange([...value, id]);
		}
	};

	return (
		<FormControl fullWidth component="fieldset" error={!!error}>
			<FormLabel
				sx={value?.length > 0 ? { color: `#4860FC` } : null}
				focused={false}
				component="legend"
			>
				{t("questionnaire.select-industry")}
			</FormLabel>
			<FormGroup>
				{options.map((industry) => (
					<FormControlLabel
						key={industry.id}
						control={
							<Checkbox
								checked={value.includes(industry.id)}
								onChange={() => handleToggle(industry.id)}
							/>
						}
						label={industry.name}
						sx={{
							alignItems: "center",
							"& .MuiFormControlLabel-label": {
								marginBottom: 0,
							},
						}}
					/>
				))}
			</FormGroup>
			{error && <FormHelperText>{error}</FormHelperText>}
		</FormControl>
	);
}
